import * as React from "react";
import {ReactElement} from "react";
import {Box, Button, styled, Typography} from "@mui/material";
import {IPageProps} from "../interfaces/components/props/IPageProps";
import {PERSONAL_PROJECTS} from "../Config";
import ProjectSection from "../components/container/ProjectSection";
import LinkButton from "../components/button/LinkButton";
import DownloadButton from "../components/button/DownloadButton";
import BackButton from "../components/button/BackButton";
import useRedirect from "../routing/useRedirect";

const Root = styled(Box)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(2),
    alignSelf: 'center',
    [theme.breakpoints.only('xs')]: {
        padding: theme.spacing(1),
    },
    [theme.breakpoints.only('sm')]: {
        padding: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2),
    },
}));

const Header = styled(Box)(({theme}) => ({
    [theme.breakpoints.only('xs')]: {
        padding: theme.spacing(1),
    },
    [theme.breakpoints.only('sm')]: {
        padding: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2),
    },
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    gap: theme.spacing(1),
}));

const Links = styled(Box)(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-evenly',
    fontSize: 25,
    fontFamily: theme.typography.fontFamily,
}));
const DownloadButtons = styled(Box)(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-evenly',
}));

interface IProps extends IPageProps {
    projectIndex: number,
}

function ProjectPage({languageTokens, projectIndex}: IProps): ReactElement {
    const projectPage = PERSONAL_PROJECTS(languageTokens)[projectIndex];
    const redirect = useRedirect();

    return (
        <Root id={"ProjectPage"} maxWidth={'lg'}>

            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
            }}>
                <BackButton/>
                <Box sx={{display: 'flex', flexDirection: 'row', gap: 2}}>
                    {
                        projectPage.previous ?
                            <Button
                                aria-label={projectPage.previous.name}
                                variant={'contained'}
                                onClick={() => redirect(projectPage.previous.route)}
                                sx={{
                                    width: 100,
                                    fontWeight: 'bold',
                                }}
                            >{projectPage.previous.name}
                            </Button> : <Box sx={{width: 100}}></Box>
                    }

                    {
                        projectPage.next ?
                            <Button
                                aria-label={projectPage.next.name}
                                variant={'contained'}
                                onClick={() => redirect(projectPage.next.route)}
                                sx={{
                                    width: 100,
                                    fontWeight: 'bold',
                                }}
                            >{projectPage.next.name}
                            </Button> : <Box sx={{width: 100}}></Box>
                    }
                </Box>
            </Box>


            <Header>
                <Typography
                    variant={"h1"}
                    sx={{    userSelect: 'text',}}
                >
                    {projectPage.mediaCardElement.name}
                </Typography>

                <Typography
                    variant={"h5"}
                    sx={{
                        userSelect: 'text',
                        alignSelf: 'center',
                }}
                >
                    {projectPage.mediaCardElement.subHeader}
                </Typography>
            </Header>

            <Links>
                {projectPage.links.map(({name, address, prefix}, i) => (
                        <LinkButton
                            key={`LinkButton${i}`}
                            name={name}
                            address={address}
                            prefix={prefix}
                        />
                    )
                )}
            </Links>

            {
                projectPage.sections
                    .map((section, i) =>
                        <ProjectSection
                            key={`${section.descriptionHeader}${i}`}
                            section={section}
                        />)

            }

            <DownloadButtons>
                {projectPage.downloads.map((file, i) => (
                    <DownloadButton
                        key={`file${i}`}
                        file={file}
                    />
                ))}
            </DownloadButtons>
        </Root>
    )
        ;
}


export default ProjectPage;
